import { useQuery } from '@tanstack/react-query'
import { getDocumentDownloadUrl } from '../api/plan-override-documents-api'
import { getApiErrorStatus } from '../utils/apiErrors'

// TTL on presigned GET URLs is 5 min; cache for 4 min to stay safely within TTL.
const DOWNLOAD_URL_STALE_TIME = 4 * 60_000

export function useDocumentDownloadUrl(
  ruleId: string | undefined,
  documentId: string | undefined,
  ruleBase?: string
) {
  const {
    data: url,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['documentDownloadUrl', ruleBase, ruleId, documentId],
    queryFn: () =>
      getDocumentDownloadUrl(ruleId ?? '', documentId ?? '', ruleBase),
    enabled: !!ruleId && !!documentId,
    staleTime: DOWNLOAD_URL_STALE_TIME,
    refetchOnWindowFocus: false,
    retry: (failureCount, err) => {
      const status = getApiErrorStatus(err)
      if (status && status >= 400 && status < 500) return false
      return failureCount < 2
    },
  })

  return { url, isLoading, error }
}
